module.exports = __webpack_public_path__ + "img/sameday_dfod.99e44c4b.png";